import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import { Divider, StepTracker, Typography } from '@telus-uds/components-web';

import { useLocaleContext } from '../context/LocaleContext';

// Custom dictionary for bilingual accessibility labels (SOF-2 format)
const STEP_TRACKER_DICTIONARY = {
  en: {
    1: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' },
    2: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' },
    3: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' },
    4: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' },
    5: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' },
    6: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' },
    7: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' },
    8: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' },
    9: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' },
    10: { stepLabel: 'Step %{stepNumber}', stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}' }
  },
  fr: {
    1: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' },
    2: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' },
    3: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' },
    4: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' },
    5: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' },
    6: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' },
    7: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' },
    8: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' },
    9: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' },
    10: { stepLabel: 'Étape %{stepNumber}', stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}' }
  }
};

const ProgressBar = ({ name, steps, currentStep = 0 }) => {
  const locale = useLocaleContext();
  const copy = locale === 'fr-CA' ? 'fr' : 'en';
  const progressSteps = steps.map(item => _.get(item, 'fields.name', ''));
  
  return (
    <>
      <div>
        <div id="title">
          <div id="title-wrapper">
            <div style={{ paddingTop: '2em' }}>
              <Typography heading="h2" variant={{ size: 'h2' }}>
                <div id="title-label">{name}</div>
              </Typography>
              <div id="title-anchors" style={{ marginTop: '10px' }} />
            </div>
          </div>
        </div>
        {steps && steps.length > 1 && (
          <StepTracker
            copy={copy}
            current={currentStep - 1}
            steps={progressSteps}
            dictionary={STEP_TRACKER_DICTIONARY}
          />
        )}
      </div>
      <Divider space={2} variant={{ inverse: true }} />
    </>
  );
};

ProgressBar.propTypes = {
  name: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ProgressBar;
